import React, { useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { FormDataConsumer, SimpleForm, TextInput } from "react-admin";
import SanitizedGrid from "../../../components/SanitizedGrid";
import FindInvoiceButton from "./FindInvoiceButton";
import { Link } from "react-router-dom";
import { getCustomerType, getResourceByCustomerType } from "utils/tools";

const FindInvoiceNumberInput = () => {
  const [invoiceInfoData, setInvoiceInfoData] = useState<any>();

  return (
    <SimpleForm toolbar={null}>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={4}>
          <TextInput source="documentNumber" label="Document Number" />
        </Grid>
        <Grid item xs={8} />

        <Grid item xs={4}>
          <FormDataConsumer>
            {({ formData }) => (
              <FindInvoiceButton
                formData={formData}
                setInvoiceInfoData={setInvoiceInfoData}
              />
            )}
          </FormDataConsumer>
        </Grid>
        <Grid item xs={8} />

        {invoiceInfoData && (
          <Grid item xs={12}>
            <Typography variant="subtitle2">
              {`This Invoice / Credit Note is belongs to ${getCustomerType(
                invoiceInfoData.type,
              )} `}
              <Link
                to={`/${getResourceByCustomerType(invoiceInfoData.type)}/${
                  invoiceInfoData.id
                }/show`}
              >{`${invoiceInfoData.firstName} ${invoiceInfoData.lastName}`}</Link>
            </Typography>
          </Grid>
        )}
      </SanitizedGrid>
    </SimpleForm>
  );
};

export default FindInvoiceNumberInput;
